import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { MdShowChart } from "react-icons/md";

const COLORS = [
  "#dc2626",
  "#3b82f6",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#ec4899",
  "#06b6d4",
  "#84cc16",
  "#ef4444",
  "#6366f1",
  "#14b8a6",
  "#d946ef",
  "#f97316",
  "#22c55e",
  "#eab308",
];

const VmCostsChart = ({ chartData, error }) => {
  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg p-3 shadow-lg">
          <p className="text-gray-300 text-sm mb-1">
            {payload[0].payload.fullName || label}
          </p>
          <p className="text-primary-cyan text-lg font-bold">
            {formatAmount(payload[0].value)}
          </p>
          {payload[0].payload.billingType && (
            <p className="text-gray-400 text-xs mt-1">
              Billing: {payload[0].payload.billingType}
            </p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-primary-dark rounded-2xl p-6 mb-8 border border-gray-700/50">
      <div className="flex items-center gap-2 mb-6 pb-3 border-b border-gray-700">
        <MdShowChart className="text-primary-cyan text-2xl" />
        <h3 className="text-xl font-semibold text-white">VM Costs Breakdown</h3>
      </div>

      {error ? (
        <div className="text-center py-8">
          <p className="text-red-400">Error loading VM costs: {error}</p>
        </div>
      ) : chartData.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-400">
            No VM cost data available for this period
          </p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              stroke="#374151"
              vertical={false}
            />
            <XAxis
              dataKey="name"
              stroke="#9CA3AF"
              tick={{ fill: "#9CA3AF", fontSize: 12 }}
              angle={-45}
              textAnchor="end"
              height={70}
              interval={0}
            />
            <YAxis
              stroke="#9CA3AF"
              tick={{ fill: "#9CA3AF", fontSize: 12 }}
              tickFormatter={(value) => `$${value}`}
            />
            <Tooltip content={<CustomTooltip />} cursor={false} />
            <Legend
              wrapperStyle={{ color: "#9CA3AF" }}
              formatter={() => "VM Cost"}
            />
            <Bar
              dataKey="cost"
              name="Cost"
              fill="#dc2626"
              radius={[8, 8, 0, 0]}
              animationDuration={1000}
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default VmCostsChart;
